import { MultiValue } from 'react-select';
import { ReactSelectOption } from 'src/types';

export const DEADLINE_IN_HOURS = 3;

export const assicurazioneRCOptions = [
	{
		value: 0,
		label: 'RC nessuna penale risarcitoria',
	},
	{
		value: 250,
		label: 'RC 250€ penale risarcitoria',
	},
];

export const assicurazioneKaskoOptions = [
	{
		value: 0,
		label: '0€',
		labelRiepilogo: 'Kasko: franchigia 0 €',
		isChecked: false,
	},
	{
		value: 500,
		label: '500€',
		labelRiepilogo: 'Kasko: franchigia 500 €',
		isChecked: true,
	},
	{
		value: 1000,
		label: '1000€',
		labelRiepilogo: 'Kasko: franchigia 1000 €',
		isChecked: false,
	},
	{
		value: 2000,
		label: '2000€',
		labelRiepilogo: 'Kasko: franchigia 2000 €',
		isChecked: false,
	},
];

export const vetturaSostitutivaOptions = [
	{
		value: 'citycar',
		label: 'City car',
		labelRiepilogo: 'Vettura Sostitutiva: City car',
		isChecked: false,
	},
	{
		value: 'media',
		label: 'Media',
		labelRiepilogo: 'Vettura Sostitutiva: Media',
		isChecked: false,
	},
	{
		value: 'superior',
		label: 'Superior',
		labelRiepilogo: 'Vettura Sostitutiva: Superior',
		isChecked: false,
	},
];

export const vetturaCommercialeSostitutivaOptions = [
	{
		value: 'lcv_small',
		label: 'Small',
		labelRiepilogo: 'Vettura Sostitutiva: Small',
		isChecked: false,
	},
	{
		value: 'lcv_medium',
		label: 'Medium',
		labelRiepilogo: 'Vettura Sostitutiva: Medium',
		isChecked: false,
	},
	{
		value: 'lcv_large',
		label: 'Large',
		labelRiepilogo: 'Vettura Sostitutiva: Large',
		isChecked: false,
	},
];

export const vetturaSostitutivaAllOptions = vetturaSostitutivaOptions.concat(vetturaCommercialeSostitutivaOptions);

export const furtoIncendioOptions = [
	{
		value: 0,
		label: '0%',
		labelRiepilogo: 'Furto e Incendio: 0%',
		isChecked: false,
	},
	{
		value: 10,
		label: '10%',
		labelRiepilogo: 'Furto e Incendio: franchigia 10%',
		isChecked: true,
	},
];

export const tipoGommaOptions = [
	{
		value: 'quality',
		label: 'Quality/Performance',
		labelRiepilogo: 'Gomme: Quality/Performance',
		isChecked: false,
		quantity: 1,
		unlimited: false,
		data: { estive: 1, invernali: 1 },
	},
	{
		unlimited: false,
		value: 'premium',
		label: 'Premium',
		labelRiepilogo: 'Gomme: Premium',
		isChecked: false,
		quantity: 1,
		data: { estive: 1, invernali: 1 },
	},
];

export const tipoClienteOptions = [
	{
		value: 'privato',
		label: 'Privato',
	},
	{
		value: 'libero_professionista',
		label: 'Libero Professionista',
	},
	{
		value: 'azienda',
		label: 'Azienda',
	},
];

export const makeDefaultQuoteRequestValues = () => ({
	marca: '',
	modello: '',
	durata: '',
	incendioFurtoScopertoPerc: '',
	kaskoFranchigia: '',
	kmAnnui: '',
	rcaPenaleRisarcitoria: '',
	anticipoNoIva: '',
	gommeYN: false,
	tipoGomma: '',
	gommeIllimitateYN: false,
	numTrenoGommeEstive: '',
	numTrenoGommeInvernali: '',
	autoSostitutivaYN: false,
	autoSostitutivaGruppo: '',
	tipoCliente: '',
	nome: '',
	cognome: '',
	ragioneSociale: '',
	requestNote: '',
	allestimento: '',
	canone: '',
	optionals: [{ descrizione: '' }],
});

export const quoteRequestEditFields = [
	'marca',
	'modello',
	'durata',
	'incendioFurtoScopertoPerc',
	'kaskoFranchigia',
	'kmAnnui',
	'rcaPenaleRisarcitoria',
	'anticipoNoIva',
	'gommeYN',
	'tipoGomma',
	'gommeIllimitateYN',
	'numTrenoGommeEstive',
	'numTrenoGommeInvernali',
	'autoSostitutivaYN',
	'autoSostitutivaGruppo',
	'tipoCliente',
	'nome',
	'cognome',
	'ragioneSociale',
	'requestNote',
	'allestimento',
	'alimentazione',
	'cambio',
	'cavalli',
	'cilindrata',
	'kw',
	'porte',
	'posti',
	'images',
	'externalPdf',
	'canone',
	'hmpPdf',
	'optionals',
	'provvigioni',
] as const;

export const emailTemplate = `
Spett.le Cliente,
<br>
con la presente le invio il preventivo per la soluzione di noleggio da lei richiesta.
In attesa di un suo gentile riscontro resto a disposizione per ogni dubbio.
<br>
Cordiali saluti
<br>
  `;

export const defaultMailData = (cc: MultiValue<ReactSelectOption> = []) => ({
	to: null,
	body: emailTemplate,
	cc,
});
